export class MedicoPlanoSaudePk {

    idMedico: number = 0;

    idPlanoSaude: number = 0;

    constructor() {
    }
}
